<div style='height: 2.125in'>
  <div id='handicap-card' fxLayout='column' fxLayoutAlign='space-between stretch' (mouseenter)='mouseIn()' (click)='downloadPdf()'>
    <div class='card-top' fxLayout='row' fxLayoutAlign='space-between center'>
      <div><i> USGA Handicap Index</i> &#174;</div>
      <div class='index'>{{playerIndex.Display}}</div>
    </div>
    <div class='card-middle' fxLayout='row' fxLayoutAlign="space-between start">
      <div fxFlex='20'>
        Name:
      </div>
      <div fxFlex='50' style='text-align: left'>
        <b>{{player.first}} {{player.last}}</b>
      </div>
      <div fxFlex='30' fxLayout='row' fxLayoutAlign='space-between center'>
        <div>ID #</div> <b>{{player.player_id | number :'6.0' | noComma}}</b>
      </div>
    </div>
    <div class='card-middle' fxLayout='row'>
      <div fxFlex='20'>
        Club:
      </div>
      <div fxFlex='80' *ngIf="player.state == 'AZ'" style='text-align: left'>
        Golf GamesKeeper (Phoenix 1)
      </div>
    </div>
    <div class='card-middle' fxLayout='row'>
      <div fxFlex='20'>Posted:</div>
      <div fxFlex='80'>{{ rounds[0].scores_posted}} rounds</div>
    </div>
    <hr style='width: 96%;padding:0;margin:0 5px' />
    <div class='card-middle' fxLayout='row' fxLayoutAlign="space-between start">
      Effective Date:<b> {{ rounds[0].effective_date.split(' ')[0] | date:'shortDate'}}</b>
    </div>
    <div class='card-scores' fxLayout='row wrap'>
      <div fxFlex='20' *ngFor='let round of rounds' [ngClass]="{'selected': round.hcp_used === 1}">
        {{round.adj_score}} {{round.type}}
      </div>
    </div>
    <div class='card-bottom' fxLayout='row' fxLayoutAlign='space-evenly center'>
      <img src="./assets/images/ggk_logo_head2.png" height='30px'/>
      <div>golfgameskeeper.com</div>
    </div>
  </div>
  <div id='card-back' (click)='downloadPdf()' *ngIf='mouseOver' fxLayout='column' fxLayoutAlign='center center'
    (mouseleave)='mouseOut()'>
    <i class="material-icons">
      save_alt
    </i>
    <div>
      Download as PDF
    </div>
  </div>
</div>